"use client";
import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {VisitorRechargeDialogFC} from "@/app/(shop)/UI/VisitorRechargeDialog/VisitorRechargeDialog";
import {PaySelectionDialogFC} from "@/app/(pay)/UI/PaySelectionDialog/PaySelectionDialogFC";

export interface ForcedSignUpDialogProps extends SDialogProps {}

//强制登陆弹窗
export const ForcedSignUpDialogFC: React.FC<ForcedSignUpDialogProps> = (props) => {
    const { fcKey, onClose, isCloseBtn } = props;
    const {closeDialog} = useDialogMethods(fcKey);
    const router = useRouter();

    const onCloseCall = () => {
        // 关闭支付方式弹窗
        if (SDialogManagerFC.getFCKey(PaySelectionDialogFC)) {
            SDialogManagerFC.closeDialog(SDialogManagerFC.getFCKey(PaySelectionDialogFC))
        }
        // 关闭游客充值弹窗
        if (SDialogManagerFC.getFCKey(VisitorRechargeDialogFC)) {
            SDialogManagerFC.closeDialog(SDialogManagerFC.getFCKey(VisitorRechargeDialogFC))
        }
        onClose?.();
        closeDialog();
    }

    useEffect(() => {
        return () => {
        };
    }, []);

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            isCloseBtn={isCloseBtn}
            isClickMaskClose={false}
            buttons={[
                {
                    label: "sign up",
                    onClick: () => {
                        onCloseCall();
                        router.push('/signup/?from=payOk');
                        // RouterMgr.signup();
                    },
                    style: "blueBtn",
                },
            ]}
        >
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                }}
            >
                <div>It seems that you are not registered.
                    Please register for the ultimate  experience</div>
            </div>
        </SDialogFC>
    );
};
